import { lazy, Suspense, useEffect } from 'react';
import { Box, CircularProgress, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer, setOpen } from '../../redux/reducer/drawerSlice';
import PageLoader from '../PageLoader';
import { ErrorWrapper } from '../../providers/ErrorBoundary';
import { RootState } from '../../redux/store';


//SalaryDrawerComponent
const EarningComponent = lazy(() => import('../../pages/compensation/masters/salary-master/components/EarningForm'));
const DeductionComponent = lazy(() => import('../../pages/compensation/masters/salary-master/components/DeductionType'));
const SalarySlipDocumentViewer = lazy(() => import('../../pages/compensation/salary/components/SalarySlipViewer'));
// const AddSalaryTemplateComponent  = lazy(() => import( '../../pages/compensation/masters/salary-template-master/AddTemplateForm'));
const AddSalaryTemplateFormulaBasedComponent = lazy(() => import('../../pages/compensation/masters/salary-template-master/add-template-new'));
const AddSalaryTemplateComponent = lazy(() => import('../../pages/compensation/masters/salary-template-master/add-template'));
const SalaryBreakup = lazy(() => import('../../pages/compensation/salary/components/salaryBreakOff'));
const ViewSalaryTemplateComponent = lazy(() => import('../../pages/compensation/masters/salary-template-master/view-template'));
const ClaimComponent = lazy(() => import('../../pages/compensation/mypay/claim-tabs/claimForm'));
const DocumentsComponent = lazy(() => import('../../pages/compensation/mypay/claim-tabs/documentsView'));
const ClaimDetailsDialog = lazy(() => import('../../pages/compensation/claim-management/ClaimDetailsDialog'));


//RecruitmentDrawerComponent
const CandidateDetails = lazy(() => import("../../pages/recruitment/candidates/candidate-detail"));
const DepartmentDetails = lazy(() => import("../../pages/recruitment/departments/department-detail"));
const Vendors = lazy(() => import("../../pages/recruitment/vendor/CreateVendor"));
const JobDetails = lazy(() => import("../../pages/recruitment/jobs/job-detail"));
const CandidateUploadDocumentApprovalView = lazy(() => import('../../pages/recruitment/candidates/candidate-detail/components/CandidateUploadDocuemntView'));
const CandidateUploadDocumentView = lazy(() => import('../../pages/recruitment/upload-documents/components/CandidateUploadDocumentView'));
const CandidateRejectedUploadDocView = lazy(() => import('../../pages/recruitment/candidates/candidate-detail/components/CandidateRejectedUploadDocView'));
const CandidateUploadedDocumentView = lazy(() => import('../../pages/recruitment/upload-documents/components/CandidateUploadedDocuemntView'));
const VendorResumeViewer = lazy(() => import('./recruitment/ResumeViewerDrawer'));
const CreateReferralDrawer = lazy(() => import('./recruitment/CreateReferralDrawer'));

//LeaveDrawerComponent
const UsedLeaveDetails = lazy(() => import("../../pages/leave/components/UsedLeaveDetails"));

//AttendanceDrawerComponent
const AttendancePolicyDetails = lazy(() => import("../../pages/attendance/components/master/policy/PolicyDetails"));

//PolicyDrawerComponent
const ViewPolicyDocument = lazy(() => import("../../pages/companyPolicy/components/Documents"));

// //EmployeeDrawerComponent
const TeamExitListForms = lazy(() => import('./employee/TeamExitListFormsDialog'));
const DocumentView = lazy(() => import("./employee/InitiatedExitUploadDocView"));
const ExitSelfInterview = lazy(() => import("./employee/ExitSelfInterview"))
const EmployeeExitFormDialog = lazy(() => import("./employee/EmployeeExitForm"));

const SpotResignationExitForm = lazy(() => import("./employee/SpotResignationExitFormDrawer"));
const TerminationExitForm = lazy(() => import("./employee/TerminationExitFormDrawer"));


//workflow
const WorkFlowDetails = lazy(() => import("./workflow-master/WorkFlowDetails"));
const ExitPolicyCreate = lazy(() => import("./workflow-master/ExitPolicyCreate"));
const ViewExitPolicyComponent = lazy(() => import("./workflow-master/ViewExitPolicyComponent"));

const ClientMastersDrawer = lazy(() => import("./masters/ClientMastersDrawer"));
const ResumeTemplateMasterForm = lazy(() => import("../../pages/recruitment/master/resume-template-master/ResumeTemplateMasterForm"));




const MapperPolicyDetails = lazy(() => import("../../pages/user/user-profile/components/Policy-details/MainPolicy"));
const ticketDocumentsViewer = lazy(() => import("../../pages/tickets/TicketDocumentsViewer"));
const ViewUploadedDeductionsList = lazy(() => import("../../pages/tax-management/manage-tax/ViewUploadedDeductionsList"));
const FnfDetails = lazy(() => import("../../components/drawer/salary/FnfDetailsDrawer"));

const ViewFnfDisbursementDrawer = lazy(() => import("../../components/drawer/salary/ViewFnfDisbursementDrawer"));

const FNFViewMainDetailsDrawer = lazy(() => import("../../components/drawer/salary/FnfMainDetailsDrawer"));

const ExitApprovarFormsDrawer = lazy(() => import("../../components/drawer/exit_exitClearance/ExitApproverDialog"));
const ReviewEmployeeExitFormDrawerComponent = lazy(() => import('./exit_exitClearance/ReviewEmployeeExitFormDrawer'));
//Tax

const ViewReimburstmentLtaDetails = lazy(() => import("./tax-management/reimbursement/ViewReimburstmentLtaDetails"));


const CommonDrawerComponent = () => {
    const dispatch = useDispatch();
    const drawer = useSelector((state: any) => state.drawer);
    const open = useSelector((state: any) => state.drawer.open);
    const deductionExemptionData = useSelector(
        (state: RootState) => state.deductionExemption.deductionExemptionData
    );


    // Map dialog types to their respective components
    const dialogComponentMap: Record<string, React.LazyExoticComponent<any> | React.FC<any>> = {

        //SalaryDrawerComponent
        'Salary Component': EarningComponent,
        'Deductions': DeductionComponent,
        'Salary Slip': SalarySlipDocumentViewer,
        'Salary Template': AddSalaryTemplateComponent,
        'Salary Template Formula based': AddSalaryTemplateFormulaBasedComponent,
        'Salary Break Off': SalaryBreakup,
        'View Salary Template': ViewSalaryTemplateComponent,
        'Claims': ClaimComponent,
        'Documents': DocumentsComponent,
        'Claim Details': ClaimDetailsDialog,

        //RecruitmentDrawerComponent
        'Job': JobDetails,
        'Candidate': CandidateDetails,
        'Department': DepartmentDetails,
        'Vendors': Vendors,
        'Upload Document': CandidateUploadDocumentApprovalView,
        'Uploaded Document Preview': CandidateUploadDocumentView,
        'Rejected Document': CandidateRejectedUploadDocView,
        'Document Preview': CandidateUploadedDocumentView,
        'Vendor Resume View': VendorResumeViewer,
        'Create Reference': CreateReferralDrawer,

        //LeaveDrawerComponent
        'Leave Summary': UsedLeaveDetails,

        //AttendanceDrawerComponent
        'Attendance Policy': AttendancePolicyDetails,

        //PolicyDrawerComponent
        'View Document': ViewPolicyDocument,

        //EmployeeDrawerComponent
        'Exit Request Approvals': TeamExitListForms,   //old flow - exit approver 

        'Exit Request Approvals Flow':ExitApprovarFormsDrawer ,   // new  flow - exit approver 

        'Document': DocumentView,
        'Self Interview': ExitSelfInterview,
        'employeeExitForm': EmployeeExitFormDialog,

        'spotResignationExitForm': SpotResignationExitForm,

        'terminationExitForm': TerminationExitForm,
        'reviewEmployeeExitForm':ReviewEmployeeExitFormDrawerComponent,

        //WorkFlowMasterComponet
        'Workflow Details': WorkFlowDetails,
        'Exit Policy Create': ExitPolicyCreate,
        'Exit Policy Update': ExitPolicyCreate,
        'View Exit Policy Details': ViewExitPolicyComponent,

        //Masters
        'Client Master Details': ClientMastersDrawer,
        'Resume Template Master': ResumeTemplateMasterForm,


        'Mapper Policy Details': MapperPolicyDetails,

        //ticker document viewer

        'Ticket Document Preview': ticketDocumentsViewer,
        'Upload Deductions' : ViewUploadedDeductionsList,

        'fnf details view' : FNFViewMainDetailsDrawer,  // FnfDetails
        "fnf disbursement details view":ViewFnfDisbursementDrawer,

        // tax

        'viewReimbursementLtaDetails' : ViewReimburstmentLtaDetails,
    };


    // Define extra props for specific dialog types
    const drawerPropsMap: Record<string, any> = {
        'Documents': { fileUrl: drawer?.file_path },
        'Claim Details': { details: drawer?.data },
        'Job': { tab: drawer.tab },
        'Candidate': { tab: drawer.tab },
        'Department': { tab: drawer.tab },
        'Vendors': { tab: drawer.tab },
        'Exit Policy Create': { PageType: 'Create' },
        'Exit Policy Update': { PageType: 'Edit' },
    };


    const handleClose = (newOpen: boolean) => () => {
        console.log(deductionExemptionData ,"000000");
        
        if (newOpen) {
            dispatch(setOpen(true));
            return;
        }
        if (!newOpen) {
            dispatch(closeDrawer());
            dispatch(setOpen(false));
        }
    };

    useEffect(() => {
        drawer?.tab !== 6 && drawer.name && dispatch(setOpen(true))
    }, [drawer]);



    // Get the selected component
    const SelectedDrawerComponent = drawer.name ? dialogComponentMap[drawer.name] : null;


    // Get extra props if available
    const extraProps = drawer.name && drawerPropsMap[drawer.name] ? drawerPropsMap[drawer.name] : {};



    return (
        <Drawer anchor='right' open={open} onClose={drawer?.onCloseNotallowed ? () => { } : handleClose(false)} PaperProps={{
            sx: { maxWidth: 1400, width: '100%' },
        }}>
            <Box sx={{ bgcolor: 'primary.main', height: 59, display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, boxShadow: 7, position: 'sticky', top: 0, zIndex: 2, padding: 2 }}>
                <Typography variant='h3' color='primary.contrastText'>{drawer.title}</Typography>
                <IconButton sx={{ color: 'primary.contrastText' }} onClick={handleClose(false)}><CloseIcon /></IconButton>
            </Box>
            <Box>
                <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>}>
                    <ErrorWrapper>
                        {SelectedDrawerComponent && <SelectedDrawerComponent {...extraProps} />}
                    </ErrorWrapper>
                </Suspense>
            </Box>
        </Drawer>
    )
}

export default CommonDrawerComponent;